<template>
  <el-dialog
    title="新增员工账号"
    :visible.sync="addVisible"
    width="1000px"
    class="my-dialog-template"
    custom-class="childAccountDialog"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-tabs v-model="radio" @tab-click="tabClick">
      <el-tab-pane label="单笔添加" name="1"></el-tab-pane>
      <el-tab-pane label="批量添加" name="2"></el-tab-pane>
    </el-tabs>
    <!-- 单笔添加 -->
    <el-form :rules="userrules" :model="addzuser" class="my-form-template addStaffForm" label-width="120px" ref="addzuser" v-show="radio == 1">
      <el-form-item label="员工真实姓名" prop="name" class="less">
        <el-input v-model.trim="addzuser.name" :maxlength="12" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="所属团队" prop="mechanId" :rules="$tools.formRule.required('请选择所属团队', 'change')" class="less">
        <merchantTree v-model="addzuser.mechanId" @change="changeOrg"></merchantTree>
      </el-form-item>
      <el-form-item label="手机号码" prop="mobile" class="less">
        <el-input class="numberInput" v-model.trim="addzuser.mobile" :maxlength="11" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idCardNo" class="less" :rules="[$tools.formRule.idCard('身份证号格式有误')]">
        <el-input class="numberInput" v-model.trim="addzuser.idCardNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="执业证号" prop="certificateNo" class="less">
        <el-input class="numberInput" v-model.trim="addzuser.certificateNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="登录账号" prop="account" class="less">
        <el-input class="numberInput" v-model.trim="addzuser.account" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="password" class="less">
        <el-input :type="showPass ? 'text' : 'password'" v-model.trim="addzuser.password" autocomplete="new-password" placeholder="登录密码">
          <img slot="suffix" class="show-pass" src="@static/images/orgManage/eye-hide.png" @click="showPass = !showPass" v-if="!showPass"/>
          <img slot="suffix" class="show-pass" src="@static/images/orgManage/eye-show.png" @click="showPass = !showPass" v-else/>
        </el-input>
      </el-form-item>
      <el-form-item label="确认登录密码" prop="agpassword" class="less">
        <el-input :type="showConfirmPass ? 'text' : 'password'" v-model.trim="addzuser.agpassword" autocomplete="new-password" placeholder="确认密码">
          <img slot="suffix" class="show-pass" src="@static/images/orgManage/eye-hide.png" @click="showConfirmPass = !showConfirmPass" v-if="!showConfirmPass"/>
          <img slot="suffix" class="show-pass" src="@static/images/orgManage/eye-show.png" @click="showConfirmPass = !showConfirmPass" v-else/>
        </el-input>
      </el-form-item>
      <div class="text3">注：新密码8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种</div>
      <el-form-item label="推荐人" prop="recommendId" class="less">
        <el-select v-model="addzuser.recommendId" filterable placeholder="请选择" clearable>
          <el-option v-for="item in staffList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="费率模板" prop="commissonTemplateCode" class="less">
        <el-select v-model="addzuser.commissonTemplateCode" filterable placeholder="请选择" clearable>
          <el-option v-for="item in feeTemplateList" :key="item.code" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </el-form-item>
      <div class="text4">
        没有费率模板？<span
          @click="
            addVisible = false;
            $router.push('/orgManage/feeTemplate');
          "
          >去新建>></span
        >
      </div>
      <el-form-item label="产品模板" class="less" prop="productTemplateCode">
        <el-select v-model="addzuser.productTemplateCode" placeholder="请选择产品模板" filterable>
          <el-option :label="item.name" :value="item.code" v-for="(item, index) in allTemplate" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <div class="text4">
        没有产品模板？<span
          @click="
            addVisible = false;
            $router.push('/childTemplate');
          "
          >去新建>></span
        >
      </div>
      <el-form-item label="状态" class="less">
        <el-switch v-model="addzuser.useStatus" active-color="#FD9201" active-text="启用" active-value="1" inactive-text="禁用" inactive-value="0"> </el-switch>
      </el-form-item>
    </el-form>
    <!-- 批量添加 -->
    <div class="batchAdd" v-show="radio == 2" v-loading="loading">
      <div class="top-tools">
        <span class="el-icon-warning-outline">请按照模板格式上传员工名单</span>
        <el-button type="text" class="xzTemplate" @click="downLoadTemplate">下载模板</el-button>
      </div>
      <!-- 导入失败/修改/校验 -->
      <template v-if="staffForm.errorList.length > 0">
        <div class="status-desc">
          <div class="msg">
            <img class="success" src="@static/images/childAccount/success.png" alt="" />
            您已成功导入<span> {{ successNum }} </span>条数据，可修改下方异常数据后进行再次保存！
          </div>
          <div class="warning">请按照模板要求上传数据！</div>
        </div>
        <el-form ref="tableForm" :model="staffForm" :rules="staffRules">
          <el-table border class="list-table" :data="staffForm.errorList" style="width: 100%">
            <el-table-column label="真实姓名" prop="name">
              <template slot-scope="scope">
                <el-form-item :prop="'errorList.' + scope.$index + '.name'" :rules="staffRules.name" :error="scope.row.errorMsg.name">
                  <el-input style="text-align: center" v-model="scope.row.name"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="登录账号" prop="account">
              <template slot-scope="scope">
                <el-form-item :prop="'errorList.' + scope.$index + '.account'" :rules="staffRules.account" :error="scope.row.errorMsg.account">
                  <el-input style="text-align: center" v-model="scope.row.account"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="登录密码" prop="password">
              <template slot-scope="scope">
                <el-form-item :prop="'errorList.' + scope.$index + '.password'" :rules="staffRules.password" :error="scope.row.errorMsg.password">
                  <el-input style="text-align: center" v-model="scope.row.password"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="产品模板code" prop="productTemplateCode">
              <template slot-scope="scope">
                <el-form-item
                  :prop="'errorList.' + scope.$index + '.productTemplateCode'"
                  :rules="staffRules.productTemplateCode"
                  :error="scope.row.errorMsg.productTemplateCode"
                >
                  <el-input style="text-align: center" v-model="scope.row.productTemplateCode"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="手机号码" prop="mobile">
              <template slot-scope="scope">
                <el-form-item :prop="'errorList.' + scope.$index + '.mobile'" :rules="staffRules.mobile" :error="scope.row.errorMsg.mobile">
                  <el-input style="text-align: center" v-model="scope.row.mobile"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="身份证号" prop="mobile" width="200">
              <template slot-scope="scope">
                <el-form-item
                  :prop="'errorList.' + scope.$index + '.idCardNo'"
                  :rules="$tools.formRule.idCard('身份证号格式有误')"
                  :error="scope.row.errorMsg.idCardNo"
                >
                  <el-input style="text-align: center" v-model="scope.row.idCardNo"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </template>
      <el-upload
        v-else
        @drop.native.stop
        :show-file-list="false"
        class="upload-demo"
        drag
        :data="deptData"
        action="/master/subAccount/batchUpdateMechanSubAccount"
        :on-success="handleFileSuccess"
        :before-upload="beforeFileUpload"
      >
        <!-- 待上传 -->
        <div v-show="!uploadFail">
          <img src="@static/images/childAccount/upload_1.png" alt="" class="upload-pic" />
          <div class="upload-text">将文件拖拽至框内上传</div>
          <el-button type="primary" class="upload-btn">上传文件</el-button>
        </div>
        <!-- 上传失败 -->
        <div v-show="uploadFail">
          <img src="@static/images/childAccount/error.png" alt="" class="upload-error" />
          <div class="upload-text1">您的文件上传解析失败，请按照模板上传文件！</div>
          <el-button type="primary" class="upload-btn1">重新上传</el-button>
        </div>
      </el-upload>
    </div>
    <div class="dialog-footer">
      <el-button type="primary" plain @click="addVisible = false">取消</el-button>
      <el-button type="primary" @click="saveForm('addzuser')" :loading="btnLoading">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import merchantTree from '@/components/merchantTree.vue'
export default {
  components: {
    merchantTree
  },
  data: () => ({
    radio: '1',
    addVisible: false,
    loading: false,
    showPass: false,
    showConfirmPass: false,
    deptData: {},
    addzuser: {
      level: '', //机构级别
      name: '',
      mechanId: '',
      idCardNo: '',
      certificateNo: '',
      useStatus: '1',
      mobile: '',
      password: '',
      agpassword: '',
      account: '',
      recommendId: '',//推荐人
      commissonTemplateCode: ''
    },
    feeTemplateList: [], // 产品模板列表
    staffList: [], // 保存员工数据
    successNum: '',// 上传成功的数量
    uploadFail: false,
    allTemplate: [],
    userrules: {
      name: [
        {
          required: true,
          message: '请输入员工姓名',
          trigger: 'blur',
        },
      ],
      password: [
        {
          required: true,
          message: '请输入密码',
          trigger: 'blur',
        },
        { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' },
      ],
      agpassword: [
        {
          required: true,
          message: '请输入确认密码',
          trigger: 'blur',
        },
        { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' },
      ],
      account: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
      mobile: [
        {
          pattern: /^1[1023456789]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur',
        },
      ]
    },
    staffForm: { errorList: [] },
    staffRules: {
      name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
      account: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
      mobile: [{ message: '手机号格式为数字', pattern: /^1[1023456789]\d{9}$/, trigger: 'blur', }],
      password: [
        { required: true, message: "请输入密码", trigger: "blur" },
        {
          trigger: "blur",
          pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$/,
          message: "密码格式不正确"
        }],
      productTemplateCode: [
        { required: true, message: '请输入产品模板code', trigger: 'blur' },
        {
          type: 'number',
          message: '输入的类型为数字',
          trigger: 'blur',
          transform(value) {
            return Number(value)
          },
        }
      ],
    },
    btnLoading: false,
    currentNode: {}, // 当前选中的节点的数据
    userinfo: {}, // 当前登录账号
  }),
  created() {
    // 当前账号数据
    const userinfo = this.$tools.getLocal("userinfo");
    this.userinfo = userinfo;
    this.getStaffList()
  },
  watch: {
    '$store.getters.currentNode': {
      handler(item) {
        if (item) {
          // 当前选中节点的数据
          this.currentNode = JSON.parse(this.$store.getters.currentNode)
          console.log('this.currentNode', this.currentNode)
          // 如果是部门批量上传员工，添加deptId参数
          if (!this.currentNode.level) {
            this.deptData = { deptId: this.currentNode.deptId }
            return this.deptData
          } else {
            // 如果是机构批量上传员工，deptId传0
            this.deptData = { deptId: '0' }
            return this.deptData
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    changeOrg({ level }) {
      if (this.addzuser.productTemplateCode || this.addzuser.commissonTemplateCode) {
        this.$set(this.addzuser, 'productTemplateCode', '')
        this.$set(this.addzuser, 'commissonTemplateCode', '')
      }
      this.getFeeTemplate()
      this.getAllTemplate()

      this.addzuser.level = level;
    },
    // 查询所有产品模板
    getAllTemplate() {
      this.$http({
        url: "/master/productTemplate/read/all",
        type: 'PUT',
        params: {
          mechanId: this.addzuser.mechanId || this.userinfo.mechanId
        }
      }).then(res => {
        this.allTemplate = res.data
      })
    },
    // 查询所有费率模板
    getFeeTemplate() {
      this.$http({
        url: '/master/commissonTemplate/read/all',
        type: 'PUT',
        params: {
          mechanId: this.addzuser.mechanId || this.userinfo.mechanId,
          type: '2'
        },
      }).then((res) => {
        this.feeTemplateList = res.data
      })
    },
    // 获取员工列表
    getStaffList() {
      this.$http({
        url: '/master/subAccount/queryUsersList',
        type: 'PUT',
        params: {
        },
      }).then((data) => {
        this.staffList = data.data
      })
    },
    open(data = null) {
      this.btnLoading = false
      this.loading = false
      this.uploadFail = false
      this.showPass = false
      this.showConfirmPass = false
      this.addVisible = true
      this.radio = '1'
      this.staffForm.errorList = []
      this.addzuser = {
        level: '',
        useStatus: '1',
        name: '',
        password: '',
        deptId: '',
      }
      if (data.mechanId) {
        this.addzuser.mechanId = data.mechanId;
      }
      this.getAllTemplate()
      this.getFeeTemplate()
      this.$nextTick(() => {
        this.$refs.addzuser && this.$refs.addzuser.clearValidate()
      })
    },
    // 下载模板
    downLoadTemplate() {
      this.$tools.daochu2(`${this.$config.api_root}/master/tpl/批量新增员工模板.xls`)
    },
    // 上传成功
    handleFileSuccess(res, file) {
      this.loading = false;
      // 上传成功
      if (res.httpCode == 200) {
        if (res.data && res.data.errorList == 0) {
          this.addVisible = false
          this.$message.success('上传成功')
          this.$parent.queryMechanSubAccount()
          return
        }
        this.successNum = res.data.successNum
        this.staffForm.errorList = res.data.errorList
      } else {
        // 上传失败，显示失败页
        this.uploadFail = true
        if (typeof (res.data) == 'string') {
          this.$message.error(res.data)
        }
      }
    },
    beforeFileUpload(file) {
      if (!file.name) {
        this.$message.error("上传文件名称不可为空");
        return false;
      }
      let fileName = file.name
      let fileType = ''
      if (fileName) {
        fileType = fileName.split('.').pop()
      }
      const isLt1GB = file.size / 1024 / 1024 < 1024;
      if (['xls', 'xlsx'].indexOf(fileType.toLowerCase()) === -1) {
        this.$message.error("上传文件只能是 xls/xlsx 格式!");
        return
      }
      if (!isLt1GB) {
        this.$message.error("上传文件大小不能超过 1GB!");
        return
      }
      this.loading = true;
      return ['xls', 'xlsx'].indexOf(fileType.toLowerCase()) != -1 && isLt1GB;
    },
    saveForm(formName) {
      if (this.radio == 1) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (
              this.addzuser.password == this.addzuser.agpassword ||
              this.addzuser.password == ''
            ) {
              this.updateMechanSubAccount()
            } else {
              this.$message.error('两次密码输入不一致')
              return
            }
          } else {
            this.$message.error('请输入信息')
          }
        })
      } else if (this.radio == 2 && this.staffForm.errorList.length > 0) {
        // 批量保存
        this.bulkImport()
      } else if (this.radio == 2 && this.staffForm.errorList.length == 0) {
        this.addVisible = false
      }
    },
    // 批量保存
    bulkImport() {
      this.btnLoading = true
      this.loading = true
      // 删除错误信息提示列表
      if (this.staffForm.errorList?.errorMsg) {
        delete this.staffForm.errorList.errorMsg
      }
      this.$refs['tableForm'].validate(valid => {
        if (valid) {
          this.$http({
            url: `/master/subAccount/batchUpdateMechanSubAccount?deptId=${this.deptData.deptId}`,
            type: 'POST',
            params: {
              list: this.staffForm.errorList
            }
          }).then(res => {
            this.loading = false
            this.btnLoading = false
            if (res.httpCode == 200) {
              // 有异常数据存在，继续修改
              if (res.data.errorList && res.data.errorList.length > 0) {
                this.successNum = res.data.successNum
                // 清空errorList，以重新触发watch监听。因为el-form-item的error属性底层使用的watch监听，在返回值相同的情况下只会首次显示。dom更新
                this.staffForm.errorList = []
                this.$nextTick(() => {
                  this.staffForm.errorList = res.data.errorList
                })
                this.$message.warning('请先修改异常数据，确认无误后再次保存')
              } else {
                // 没有异常数据，导入成功
                this.$message.success('保存成功')
                this.addVisible = false
                this.$parent.queryMechanSubAccount()
              }
            }
          }).catch(e => {
            this.loading = false
            this.btnLoading = false
          })
        } else {
          this.loading = false
          this.btnLoading = false
          this.$message.warning('请按模板格式正确填写信息')
        }
      })
    },
    //更新修改子机构
    updateMechanSubAccount() {
      this.btnLoading = true
      this.$http({
        url: '/master/subAccount/updateMechanUser',
        type: 'put',
        params: this.addzuser,
      }).then((data) => {
        this.btnLoading = false
        if (data.httpCode == 200) {
          this.addVisible = false
          this.$parent.queryMechanSubAccount()
          this.$message.success('保存成功')
        }
      }).catch(e => {
        this.btnLoading = false
      })
    },
    tabClick() { },
  },
}
</script>
<style lang='scss'>
.childAccountDialog {
  .el-dialog__body {
    padding-top: 0;
  }
  .el-input__validateIcon {
    display: none !important;
  }
  .my-form-template {
    .el-form-item {
      .el-form-item__content {
        .el-cascader {
          line-height: 32px;
        }
      }
    }
    .el-form-item {
      .el-form-item__content {
        margin-left: 0 !important;
      }
      .el-switch {
        width: auto;
      }
    }
    .text3,
    .text4 {
      font-weight: 400;
      line-height: 30px;
      text-align: left;
      margin-bottom: 30px;
      font-size: 12px;
      color: #999999;
    }
    .text3 {
      margin-left: 38px;
    }
    .text4 {
      margin-left: -20px;
      font-size: 14px;
      span {
        cursor: pointer;
        color: #fd9201;
      }
    }
    
    .show-pass {
      cursor: pointer;
      width: 16px;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2;
    }
  }
  .batchAdd {
    margin-bottom: 40px;
    .top-tools {
      margin-bottom: 27px;
      font-size: 14px;
      line-height: 20px;
      color: #666666;
      .el-icon-warning-outline:before,
      .el-icon-circle-check::before {
        color: #fd9201;
        margin-right: 5px;
        font-size: 14px;
      }
      .xzTemplate {
        margin-left: 30px;
        font-weight: 500;
        text-decoration: underline;
        text-underline-offset: 2px;
      }
    }
    .upload-demo {
      .el-upload {
        width: 100%;
        .el-upload-dragger {
          background: #f8f8f9;
          width: 100%;
          height: 310px;
          .upload-error {
            width: 40px;
            height: 40px;
            margin-top: 78px;
          }
          .upload-pic {
            width: 100px;
            height: 100px;
            margin-top: 48px;
          }
          .upload-text,
          .upload-text1 {
            font-size: 14px;
            line-height: 20px;
            color: #888888;
            margin-top: 20px;
          }
          .upload-text1 {
            margin-top: 30px;
          }
          .upload-btn,
          .upload-btn1 {
            margin-top: 30px;
            width: 100px;
            height: 32px;
            padding: 0;
          }
          .upload-btn1 {
            margin-top: 50px;
          }
        }
      }
    }
    .status-desc {
      text-align: center;
      margin-bottom: 30px;
      width: 740px;
      height: 90px;
      background: #f8f8f9;
      border: 1px dashed #dbdee2;
      opacity: 1;
      border-radius: 4px;
      .msg {
        margin-top: 19px;
        font-size: 14px;
        line-height: 20px;
        color: #333333;
        .success {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
        span {
          color: #fd9201;
        }
      }
      .warning {
        margin-top: 12px;
        color: #fd9201;
      }
    }
    .list-table {
      .el-table__body-wrapper {
        .el-table__body {
          .el-table__row {
            .cell {
              height: 60px !important;
            }
          }
        }
      }
    }
    .el-form-item {
      margin-bottom: 0;
    }
    .el-input {
      input {
        text-align: center;
      }
    }
  }
  .checkBox {
    margin-bottom: 30px;
  }
}
</style>
